// Plan → feature matrix, shared by the client (useFeatures) and the server routes that
// enforce it. See app/composables/useFeatures.ts for how the active plan is resolved.

export type PlanId = 'free' | 'pro' | 'studio'

export type FeatureKey =
  | 'slicer.autoSuggest' // ML/CV auto-slice cut suggestions
  | 'slicer.autoSlice' // one-click full auto-slice (horizontal + vertical cuts)
  | 'slicer.dragEdit' // drag + per-cut select editing
  | 'slicer.bandSelect' // select an individual band/slice to act on it

// Which features each plan includes. Higher tiers are supersets here, but that's not required.
export const PLAN_FEATURES: Record<PlanId, FeatureKey[]> = {
  free: [],
  pro: ['slicer.dragEdit', 'slicer.bandSelect'],
  studio: ['slicer.dragEdit', 'slicer.bandSelect', 'slicer.autoSuggest', 'slicer.autoSlice'],
}

/** A configured plan value, or the top tier when it's missing or unknown. */
export function toPlan(v: unknown): PlanId {
  return typeof v === 'string' && v in PLAN_FEATURES ? (v as PlanId) : 'studio'
}
